import { message } from "antd";
import {copyTextToClipboard, generateUUID2} from "../../utils";
import { t } from "i18next";
import {ipcSend} from "../../common/ipc";
import {findItemByUrl, updateCard} from "@model/card";

export async function handleWebviewMenu(szAction:any,data:any,webview:any,callback:any){
    if (szAction == "copyLink"){
        copyTextToClipboard(data.url);
        message.info(t('Link copied to clipboard'))
    }else if (szAction == 'OpenInPopup'){

    }else if (szAction == 'openInFullscreen'){

    }else if (szAction == 'addToLibrary'){
        const dbItem = await findItemByUrl(data.url);
        if (!dbItem){
            const item = {
                id:generateUUID2(),
                type:'webLink',
                createTime:Date.now(),
                description:'',
                fileName:decodeURI(data.url),
                name:data.title,
                icon:data.favicon,
                updateTime:Date.now(),
            }
            updateCard(item).then(res=>{
                message.info(t('Has added'));
                window.globalRefreshList('refreshLibraryList_');
            });
        }else{
            message.info(t('LibraryExist'));
        }
    }else if (szAction == 'openFromLibrary'){
        window.showDialogChooseCardPdf((item) => {
            if (item) {
                callback({action:'open',data:item})
            }
        },'webLink')
    }else if (szAction == 'openInDefaultBrowser'){
        let szUrl = data.url;
        if (!data.url.startsWith('http')){
            szUrl = 'https://'+data.url;
        }
        ipcSend('open-url',szUrl);
    }else if (szAction == "zoomIn"){
        const zf = webview.getZoomFactor();
        webview.setZoomFactor(zf + 0.1);
    }else if (szAction == "resetZoom"){
        webview.setZoomFactor(1.0);
    }else if (szAction == "zoomOut"){
        const zf = webview.getZoomFactor();
        webview.setZoomFactor(zf - 0.1);
    }else if (szAction == "search"){
        callback({action:'search'})
    }else if (szAction == "setting"){
        window.showSettingDialog('webview')
    }
}